import { useEffect, useState } from "react";
import { useAuthenticationContext } from "../context/AuthenticationContext";
import Confetti from "./Confetti";
import PremiumUpsellModal from "./modals/PremiumUpsellModal";

interface PremiumUpsellHandlerProps {
  onboardingCompleted: boolean;
  resetOnboardingCompleted: () => void;
}

export default function PremiumUpsellHandler({
  onboardingCompleted,
  resetOnboardingCompleted
}: PremiumUpsellHandlerProps) {
  const { user } = useAuthenticationContext();
  const [showUpsellModal, setShowUpsellModal] = useState(false);
  const [showPremiumConfetti, setShowPremiumConfetti] = useState(false);

  useEffect(() => {
    // Only show the premium upsell modal if:
    // 1. The user has just completed onboarding
    // 2. The user's plan is FREE
    if (onboardingCompleted && user) {
      // Show upsell modal for FREE users, not for SUBSCRIBER or OSD users
      if (user.plan === "FREE") {
        setShowUpsellModal(true);
      } else {
        // If user is already a subscriber, show a celebratory confetti
        // to welcome them as premium members
        setShowPremiumConfetti(true);

        // Stop confetti after 4 seconds
        setTimeout(() => {
          setShowPremiumConfetti(false);
          // Reset the onboarding completed flag
          resetOnboardingCompleted();
        }, 4000);
      }
    }
  }, [onboardingCompleted, user, resetOnboardingCompleted]);

  useEffect(() => {
    if (user?.filled_questionnaire && user?.subscriptions?.length === 0) {
      setShowUpsellModal(true);
    }
  }, [user]);

  const handleCloseUpsellModal = () => {
    setShowUpsellModal(false);
    resetOnboardingCompleted();
  };

  return (
    <>
      {showUpsellModal && (
        <PremiumUpsellModal
          open={showUpsellModal}
          onClose={handleCloseUpsellModal}
        />
      )}

      {/* Show special confetti for premium users */}
      <Confetti
        active={showPremiumConfetti}
        duration={4000}
        particleDensity={75} // More confetti for premium users!
      />
    </>
  );
}